import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {WidgetDetail} from '../../../../../../domain/widget/model/widget-detail';
import {DebtSummary} from '../../../../../../domain/debt-summary/model/debt-summary';
import {WidgetSize} from '../../../../../../domain/widget/model/widget-size.enum';
import {AmountFormatterService} from '../../../../../services/amount-formatter.service';
import {DomainUrlService} from '../../../../../../application/config/domain-url.service';
import {UserContextService} from '../../../../../../application/app-context/user-context/user-context.service';
import {ApplicationName} from '../../../../../../domain/core/model/aplication-name.enum';
import {DebtByRateType} from '../../../../../../domain/debt-summary/model/debt-by-rate-type';

@Component({
             selector: 'app-widget-debt-summary',
             templateUrl: './home-dashboard-widget-debt-summary.component.html',
             styleUrls: ['./home-dashboard-widget-debt-summary.component.scss']
           })
export class HomeDashboardWidgetDebtSummaryComponent implements OnInit {

  @Input()
  public widget: WidgetDetail | undefined;
  @Input()
  public debtSummary: DebtSummary;

  public WidgetSize = WidgetSize;
  public insitoAccountId;
  public clientFloatingRateRepartition: number;
  public clientFixedRateRepartition: number;
  public clientStructuredRateRepartition: number;
  public clientLivretARateRepartition: number;

  public clientLivretASubRateRepartition: number;
  public clientFloatingSubRateRepartition: number;
  public clientFixedSubRateRepartition: number;

  @Output() actionEvent = new EventEmitter<string>();

  constructor(public amountFormatterService: AmountFormatterService,
              private domainUrl: DomainUrlService,
              private userContextService: UserContextService) {
    const userContext = this.userContextService.getUserContext();
    const currentAccount = userContext.user.accounts.find(account => account.accountId === userContext.accountId);
    this.insitoAccountId = currentAccount.applications.find(application => (application.targetApp === ApplicationName.INSITO) && application.accountSynchId !== null).accountSynchId;
  }

  ngOnInit(): void {
    this.clientFixedRateRepartition = this.getValue(this.debtSummary.fixe);
    this.clientFloatingRateRepartition = this.getValue(this.debtSummary.variable);
    this.clientStructuredRateRepartition = this.getValue(this.debtSummary.structure);
    this.clientLivretARateRepartition = this.getValue(this.debtSummary.livretA);

    this.initDisplaySubRate();

  }

  private initDisplaySubRate(): void {
    this.clientLivretASubRateRepartition = (
                                             (this.clientLivretARateRepartition * 100) / (this.clientLivretARateRepartition
                                                                                          + this.clientStructuredRateRepartition)
                                           ) + this.getAdditionalDisplayValue(this.clientLivretARateRepartition);

    this.clientFloatingSubRateRepartition = (
                                              (this.clientFloatingRateRepartition * 100) / (this.clientLivretARateRepartition
                                                                                            + this.clientStructuredRateRepartition
                                                                                            + this.clientFloatingRateRepartition)
                                            ) + this.getAdditionalDisplayValue(this.clientFloatingRateRepartition);

    this.clientFixedSubRateRepartition = (
                                           (this.clientFixedRateRepartition * 100) / (this.clientLivretARateRepartition
                                                                                      + this.clientStructuredRateRepartition
                                                                                      + this.clientFloatingRateRepartition
                                                                                      + this.clientFixedRateRepartition)
                                         ) + this.getAdditionalDisplayValue(this.clientFixedRateRepartition);
  }

  public goToMonthlySummaryPage(): string {
    return `${this.domainUrl.getInsitoUrl()}?accountId=${this.insitoAccountId}&redirectLink=analysesEtSyntheses`;
  }

  private getValue(rateType: DebtByRateType): number {
    return (rateType.amount.value / this.debtSummary.crd.value) * 100;
  }

  private getAdditionalDisplayValue(value: number): number {
    return value > 93 || value < 7 ? 0 : 7;
  }
}
